import colors from 'vuetify/es5/util/colors'

export default {
  primary: colors.blueGrey.base,
  secondary: colors.blueGrey.lighten1,
  accent: colors.deepOrange.base,
  error: colors.red.base,
  warning: colors.yellow.base,
  info: colors.blue.base,
  success: colors.green.base
}
